import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_LIST: '/transfer/get/list',

};

export const TransferService = {
    getList: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_LIST, params);
    },
};

export default TransferService;
